import { render, staticRenderFns } from "./StatisticHrFeedTableDetail.vue?vue&type=template&id=55af5d18"
import script from "./StatisticHrFeedTableDetail.vue?vue&type=script&lang=js"
export * from "./StatisticHrFeedTableDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports